import { PiniaPluginContext, Store } from "pinia";
import { watch } from "vue";

/**
 * Load the pinia stores from the session storage
 */
function loadPiniaState(store: Store) {
    const savedState = sessionStorage.getItem(`pinia_${store.$id}`);
    if (savedState) {
        store.$state = { ...store.$state, ...JSON.parse(savedState) };
    } else {
        sessionStorage.setItem(`pinia_${store.$id}`, JSON.stringify(store.$state));
    }
}
/**
 * Plugin that makes stores with the word "<persistent>" session persistent
 * @param context
 */
export function piniaPersist(context: PiniaPluginContext) {
    // Check if the store is persistent
    if (context.store.$id.includes("<persistent>")) {
        loadPiniaState(context.store);
        watch(
            context.store.$state,
            state => {
                // Persist the whole state to the local storage whenever it changes
                sessionStorage.setItem(`pinia_${context.store.$id}`, JSON.stringify(state));
            },
            { deep: true }
        );
    }
}
